export class MinimalProvider {
  id: number;
  npi: string;
  status: string;
  fullName: string;
  displaySpecialty: string;
  specialties: string[];
  recommendedReferralSpecialty: string;
}
